import React, { useState, useEffect , useRef } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { jwtDecode } from 'jwt-decode';
import { FiTrash2, FiDownload, FiFileText } from 'react-icons/fi';
import { GoogleMap, Marker, useLoadScript,Autocomplete } from "@react-google-maps/api";
import LocationPicker from "../.././LocationPicker";


const center = {
  lat: 40.0853,
  lng: 22.3584,
};

const Container = styled.div`
  // margin: 50px;
  // padding: 2rem;
  // background: #fff;
  // box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  // border-radius: 8px;

  margin-bottom: 50px;

   @media (max-width: 768px) {
    margin-bottom: 20px; 
     text-align: center;
  }

`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 25px;
  }
`;

const Title = styled.h2`
  color: #385963;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FieldWrapper = styled.div``;

const FieldTitle = styled.h4`
  margin-bottom: 1rem;
  color: #385963;
   @media (max-width: 768px) {
   font-size: 16px;
  }
`;

const LangRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LocationRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  margin-bottom:  20px;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #385963;
  }

  input, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }s

  textarea {
    resize: vertical;
    min-height: 100px;
  }

  @media (max-width: 768px) {
   font-size: 14px;
   margin-bottom:10px;
  }
`;

const Button = styled.button`
  background-color: #385963;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 2rem;
  place-self: center;

  &:hover {
    background-color: #2c4a52;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  background-color: white;
  color: #385963;

  &:focus {
    border-color: #385963;
    outline: none;
    box-shadow: 0 0 0 2px rgba(56, 89, 99, 0.2);
  }

  option {
    color: #385963;
  }
`;


const SinglePhotoContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-items: center;
  margin-top: 10px;

  img{
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;


const DeleteButton = styled.button`
  background-color: #ff4d4d;  /* Red background */
  color: white;
  border: none;
  padding: 0.5rem 1rem;  /* Smaller padding */
  font-size: 0.9rem;      /* Smaller font size */
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  
  &:hover {
    background-color: #e60000;  /* Darker red on hover */
  }
`;


const PhotoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom:20px;

  img{
    border-radius: 5px;
  }

    @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
  
`;


const FileListContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;


const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 50px;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 12px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  margin-right: 20px;

  svg {
    color: #385963;
    font-size: 20px;
  }

  span {
    font-weight: 500;
    color: #333;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const FileActions = styled.div`
  display: flex;
  gap: 10px;

  button, a {
    display: flex;
    align-items: center;
    // gap: 5px;
    background: none;
    border: none;
    color: #385963;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.2s ease;

    svg {
      font-size: 18px;
    }

    &:hover {
      background-color: #d6e4e9;
      color: #2e4852;
    }
  }

  button.delete {
    color: #e74c3c;

    &:hover {
      background-color: #f9d6d5;
      color: #c0392b;
    }
  }

   @media (max-width: 768px) {
       gap: 10px;
        button, a {
          padding: 2px
        }
    }
`;


// FilePlaceTypeEnum
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
  File: 4
};

const RoleEnums = {
  RegisteredUser : 0 ,
  Provider : 1,
  Admin : 2,
  PreApprovedProvider : 3,
};

const StatusEnum = {
  Pending: 0,
  Approved: 1,
  Rejected: 2,
  ForRevision: 3,
};

const AddEvent = ({ onAddSuccess }) => {
   const BASE_URL = process.env.REACT_APP_BASE_URL;
   const tokenString = sessionStorage.getItem("token");
   const { t, i18n } = useTranslation();
   const navigate = useNavigate();
   const [categories, setCategories] = useState([]);
   const categoryInputRef = useRef(null);
   const galleryInputRef = useRef(null);
   const posterInputRef = useRef(null); 
   const [loggedInProvider, setLoggedInProvider] = useState(null);
   const decodedToken = jwtDecode(decodeURIComponent(tokenString));
   const userName = decodedToken.name;
   const email = decodedToken.unique_name;
   const [uploadSuccess, setUploadSuccess] = useState(false);
   const [modalVisible, setModalVisible] = useState(false);
   const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
   const filesInputRef = useRef(null);

 const [form, setForm] = useState({
    name: { gr: '', en: '' },
    description: { gr: '', en: '' },
    location: { latitude: '', longitude: '' },
    categoryId: '',
    phone: '',       // new
    email: '',       // new
    siteLink: '',  
    providerId: '',  // new
    staus: null,
    startDate: '',   // new (ISO datetime string)
    endDate: '',  
    posterPhoto: null,
    photos: [],
    files: [], 
  });

  const { isLoaded } = useLoadScript({
  googleMapsApiKey: "AIzaSyCIrKrxTVDqlcRVFNyNMm5iS869G7RYvuc",
  libraries: ["places"],
});

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}EventCategory`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching Categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (field, value, lang = null) => {
    if (lang) {
      setForm((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [lang]: value,
        },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  
const openPreview = (url) => {
  if (pdfPreviewUrl) {
    URL.revokeObjectURL(pdfPreviewUrl); // Cleanup previous preview URL
  }

  if (isMobile) {
    window.open(url, '_blank');
  } else {
    setPdfPreviewUrl(url);
    setModalVisible(true);
  }
};

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


const handleFileChange = (e, isMultiple, field) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const fileArray = Array.from(files);


  if (isMultiple && field) {
  setForm(prev => ({
    ...prev,
    [field]: [...prev[field], ...fileArray],
  }));
  return;
}

  if (field) {
    // Single file to a field
    setForm(prev => ({
      ...prev,
      [field]: fileArray[0],
    }));
    return;
  }


  const imageFiles = fileArray.filter(file => file.type.startsWith('image/'));
  const pdfFiles = fileArray.filter(file => file.type === 'application/pdf');

  setForm(prev => ({
    ...prev,
    photos: [...prev.photos, ...imageFiles],
    files: [...prev.files, ...pdfFiles],
  }));
};



const uploadFiles = async (id, files, types) => {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append('uploadFiles', files[i]);
    formData.append('uploadFileTypes', types[i].toString());
  }

  try {
    const response = await fetch(`${BASE_URL}Event/${id}/uploadFiles`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenString}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
       alert(t('uploadFilesFailedPleaseEditAndTryAgain'));
      throw new Error(errorText);
      
    }

  } catch (error) {
    console.error('Upload error:', error);
  }
};


  const handleCategoryChange = (value) => {
    setForm((prev) => ({
      ...prev,
      categoryId: value,
    }));
  };

  useEffect(() => {
  const fetchLoggedInProvider = async () => {
    try {
      const response = await fetch(`${BASE_URL}ProviderProfile/get`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
      });

      if (!response.ok) throw new Error('Failed to fetch provider profile');

      const data = await response.json();
      setLoggedInProvider(data);

      // Set form fields automatically
      setForm(prev => ({
        ...prev,
        providerId: data.userId, // Assuming the provider ID is in `data.id`
      }));
    } catch (err) {
      console.error('Error fetching provider profile:', err);
    }
  };

  fetchLoggedInProvider();
}, []);



 const handleSubmit = async (e) => {
 e.preventDefault();

 const payload = {
  name: form.name,
  description: form.description,
  categoryId: form.categoryId,
  phone: form.phone,
  email: form.email,
  siteLink: form.siteLink,
  providerId: form.providerId,
  startDate: new Date(form.startDate).toISOString(),
  endDate: new Date(form.endDate).toISOString(),
  location: {
    latitude: parseFloat(form.location.latitude),
    longitude: parseFloat(form.location.longitude),
  },
  status: 0,
  // linkedEventId: null,
};

    if (
    form.location.latitude < -90 || form.location.latitude > 90 ||
    form.location.longitude < -180 || form.location.longitude > 180
  ) {
    alert("Invalid coordinates. Please provide valid latitude and longitude.");
    return;
  }


  try {
    const response = await fetch(`${BASE_URL}Event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`, 
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create Event');
    }

    const createdData = await response.json();
    const newId = createdData.id; //API returns the new id

    // Prepare files and types for upload
    const uploadFileList = [];
    const fileTypes = [];


    if (form.posterPhoto) {
      uploadFileList.push(form.posterPhoto);
      fileTypes.push(FILE_PLACE_TYPE.Poster); 
    }


    if (form.photos.length > 0) {
      uploadFileList.push(...form.photos);
      fileTypes.push(...Array(form.photos.length).fill(FILE_PLACE_TYPE.Gallery));
    }

    if (form.files.length > 0) {
      uploadFileList.push(...form.files);
      fileTypes.push(...Array(form.files.length).fill(FILE_PLACE_TYPE.File));
    }

    if (uploadFileList.length > 0) {
      await uploadFiles(newId, uploadFileList, fileTypes);
    }

    alert(t('eventAddedSuccessfully'));
      onAddSuccess();
    navigate('/profile-menu-provider');
  } catch (error) {
    console.error('Error creating Event:', error);
    alert(t('errorCreatingEvent') + ': ' + error.message);
  }
};


  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const handleOpenModal = (img) => {
    if (!img) return;
    setModalImage(typeof img === 'string' ? img : URL.createObjectURL(img));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage('');
  };



const handleDeleteNewGalleryPhoto = (index) => {
  setForm(prev => ({
    ...prev,
    photos: prev.photos.filter((_, i) => i !== index),
  }));
    // Optional: reset input when all are removed
  if (form.photos.length === 1 && galleryInputRef.current) {
    galleryInputRef.current.value = '';
  }
};

const handleDeleteFile = (index) => {
  setForm(prev => ({
    ...prev,
    files: prev.files.filter((_, i) => i !== index),
  }));
    // Optional: reset input when all are removed
  if (form.files.length === 1 && filesInputRef.current) {
   filesInputRef.current.value = '';
  }
};

const handleDeletePosterPhoto = () => {
  setForm(prev => ({
    ...prev,
    posterPhoto: null,
    posterBase64Src: '', // optional
  }));
  if (posterInputRef.current) {
    posterInputRef.current.value = '';
  }
};


  return (
    <Container>

      <form onSubmit={handleSubmit}>
        <FormWrapper>

          {['name', 'description'].map((field) => (
            <FieldWrapper key={field}>
              <FieldTitle>{t(field)}</FieldTitle>
              <LangRow>
                <FieldGroup>
                  <label>{t(field)} (Ελληνικά)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                      required
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                      required
                    />
                  )}
                </FieldGroup>

                <FieldGroup>
                  <label>{t(field)} (English)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                      required
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                      required
                    />
                  )}
                </FieldGroup>
              </LangRow>
            </FieldWrapper>
          ))}

          <FieldWrapper>
            <FieldTitle>{t('category')}</FieldTitle>
            <FieldGroup>
              <StyledSelect
                value={form.categoryId}
                onChange={(e) => handleCategoryChange(e.target.value)}
                required
              >
                <option value="" disabled>
                  {t('selectCategory')}
                </option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name?.[i18n.language] || cat.name?.en}
                  </option>
                ))}
              </StyledSelect>
            </FieldGroup>
          </FieldWrapper>
          
         <FieldWrapper>
            <FieldTitle>{t("location")}</FieldTitle>
            <LocationPicker
              location={form.location}
              onChange={(loc) => handleChange("location", loc)}
              isLoaded={isLoaded}
            />
         </FieldWrapper>
 

      <FieldWrapper>
        <FieldTitle>{t('phone')}</FieldTitle>
        <FieldGroup>
          <PhoneInput
            international
            defaultCountry="GR"   
            value={form.phone}
            onChange={(value) => handleChange('phone', value)}
            required
            countryCallingCodeEditable={false}
            placeholder={t('enterPhone')}
          />
        </FieldGroup>
      </FieldWrapper>


      <FieldWrapper>
        <FieldTitle>{t('email')}</FieldTitle>
        <FieldGroup>
          <input
            type="email"
            value={form.email}
            onChange={(e) => handleChange('email', e.target.value)}
            required
          />
        </FieldGroup>
      </FieldWrapper>

        <FieldWrapper>
        <FieldTitle>{t('link')}</FieldTitle>
        <FieldGroup>
          <input
            type="url"
            value={form.siteLink}
            onChange={(e) => handleChange('siteLink', e.target.value)}
          />
        </FieldGroup>
      </FieldWrapper>


      <FieldWrapper>
        <FieldTitle>{t('startDate')}</FieldTitle>
        <FieldGroup>
          <input
            type="datetime-local"
            value={form.startDate}
            onChange={(e) => handleChange('startDate', e.target.value)}
            required
          />
        </FieldGroup>
      </FieldWrapper>

      <FieldWrapper>
        <FieldTitle>{t('endDate')}</FieldTitle>
        <FieldGroup>
          <input
            type="datetime-local"
            value={form.endDate}
            onChange={(e) => handleChange('endDate', e.target.value)}
            required
          />
        </FieldGroup>
      </FieldWrapper>

     <FieldWrapper>
        <FieldTitle>{t('providerName')}</FieldTitle>
        <FieldGroup>
          <span>{userName}</span>
        </FieldGroup>
      </FieldWrapper>

     <FieldGroup>
      <FieldTitle>{t('files')}</FieldTitle>
       <FieldGroup>
           <input
             type="file"
             accept="application/pdf"
             multiple
             onChange={(e) => handleFileChange(e, true)}
             ref={filesInputRef}
             required
           />
        </FieldGroup>
      <FileListContainer>
            {form.files.map((file, index) => (
              <FileCard key={index}>
                <FileInfo>
                  <span>{file.name}</span>
                </FileInfo>
                <FileActions>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                      openPreview(URL.createObjectURL(file));
                    }}
                    title={t('preview')}
                  >
                    <FiFileText />
                  </a>
                  <button
                    className="delete"
                    type="button"
                    onClick={() => handleDeleteFile(index)}
                    title={t('delete')}
                  >
                    <FiTrash2 />
                  </button>
                </FileActions>
              </FileCard>
            ))}
          </FileListContainer>
       </FieldGroup>

              <FieldWrapper>
            <FieldTitle>{t('posterPhoto')}</FieldTitle>
            <FieldGroup>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, false, 'posterPhoto')} 
                ref={posterInputRef}
             
              />
            </FieldGroup>
            {(form.posterPhoto || form.existingPosterFileName) && (
              <SinglePhotoContainer>
                <img
                  src={
                    form.posterPhoto
                      ? URL.createObjectURL(form.posterPhoto)
                      : form.posterBase64Src
                  }
                  alt="Poster"
                  style={{ width: 120, height: 120, objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() =>
                    handleOpenModal(
                      form.posterPhoto
                        ? URL.createObjectURL(form.posterPhoto)
                        : form.posterBase64Src
                    )
                  }
                />
                <DeleteButton type="button" onClick={handleDeletePosterPhoto}>
                  {t('delete')}
                </DeleteButton>
              </SinglePhotoContainer>
            )}
          </FieldWrapper> 

          <FieldWrapper>
            <FieldTitle>{t('galleryPhotos')}</FieldTitle>
            <FieldGroup>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) =>  handleFileChange(e, true, 'photos')}
                ref={galleryInputRef}
              />
            </FieldGroup>
             {form.photos.map((photo, index) => (
               <PhotoItem key={`new-${index}`}>
                 <img
                   src={URL.createObjectURL(photo)}
                   alt={`Gallery new ${index}`}
                   style={{ width: 100, height: 100, objectFit: 'cover', cursor: 'pointer' }}
                   onClick={() => handleOpenModal(URL.createObjectURL(photo))}
                 />
                 <DeleteButton type="button" onClick={() => handleDeleteNewGalleryPhoto(index)}>
                   {t('delete')}
                 </DeleteButton>
               </PhotoItem>
             ))}
          </FieldWrapper>

          <Button type="submit">{t('save')}</Button>
        </FormWrapper>
      </form>
    </Container>
  );
};

export default AddEvent;

